<template>
  <FormContainer without-divider>
    <template #title>Établissement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Raison Sociale"
          class="col-22 col-sm-36"
          :required="meta.employeur?.etablissement?.denomination?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.denomination?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="Siret de l'établissement d'exécution du contrat"
          class="col-14 col-sm-36"
          :required="meta.employeur?.etablissement?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.siret?.valeur?.$messageErreurDirty!"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'

  const store = useDemandeCPROStore()
  const { meta, model } = storeToRefs(store)
</script>
